(function () {
	'use strict';

	angular
		.module('as.search')
		.controller('SearchController', SearchController)
		.controller('OpenDownloadSearchModalController', OpenDownloadSearchModalController);


	SearchController.$inject = ['$scope', '$location', '$q', '$filter', '$window', 'asMessages', '$timeout', 'ModalService', 'suggestions', '$stateParams', 'sidetopHttp', '$state','$rootScope','adminRights','invitation','asNetwork','lostUserService'];

	function SearchController($scope, $location, $q, $filter, $window, asMessages, $timeout, ModalService, suggestions, $stateParams, sidetopHttp, $state,$rootScope,adminRights,invitation,asNetwork,lostUserService) {
		//Variables
		
		if($rootScope.app_data.same_com_log) asNetwork.networkingStatus(0);
		
		$scope.categories_animation = false; $timeout(function () {$scope.categories_animation = true;},2000);

		$scope.$state = $state;
		var c_i = $rootScope.app_data.cid;
		var myUid = $rootScope.app_data.uid;
		$scope.showDrawer = false;
		var searchParams = {};
		var isFetching = false;
		var searchNo = 0;
		var searchTime = 0;
		var searchType = 'top';
		var checkboxUsed = 'none';
		searchParams.company = [];
		searchParams.city = [];
		searchParams.department = [];
		searchParams.degree = [];
		searchParams.yop = [];
		searchParams.subinst = [];
		searchParams.sector = [];
		searchParams.skill = [];
		searchParams.gender = [];
		searchParams.hometown = [];
		searchParams.designation = [];
		var institute_establish_year = $rootScope.app_data.data.establish_year;
		$scope.urlToShare = $location.absUrl();

		// searchParams.name = '';
		var allPeople = [];
		var randomDefault = Math.floor(Math.random() * (4 - 1 + 1)) + 1;
		var allDataStream = 1;
		var all_people_stream = 2;
		var ScrollMoreFlag = 0;
		$scope.departments = [];
		$scope.sectors = [];
		$scope.skills = [];
		$scope.degrees = [];
		$scope.subInstCheckboxes = {};
		var limit_inst = 4;
		var subinst1 = [];
		var idData = {
			id: c_i
		};

		$scope.company_id = -1;
		$scope.designation_id = -1;
		$scope.location_id = -1;
		$scope.hometown_id = -1;
		$scope.department_id = -1;
		$scope.degree_id = -1;
		$scope.yop_id = -1;
		$scope.subinst_id = -1;

		var results_top_div = document.getElementById("countDiv");

		$scope.isFetching1 = false; //for all profile fetching wihtout criteria
		var canceller;
		var canceller1;

		var arrayOfParams = [];
		arrayOfParams = getSearchParamChecked(["company", "designation", "city", "hometown", "yop", "department", "degree", "subinst", "name", "role", "sector", "gender", "skill"], arrayOfParams);
		$scope.isEmpty = true;
		$scope.s3_url = s3base;
		var checkboxes = {};
		var network = [];
		var downloadPermit = false;
		var people = {};
		$scope.gendersOpt = [{id: 1,name: 'Male'}, {id: 2,name: 'Female'}, {id: 3,name: 'Other'}];

		//Function Bindings

		$scope.toggleDrawer = toggleDrawer;
		$scope.peopleSelected = peopleSelected;
		$scope.filterDeptOnChange = filterDeptOnChange;
		$scope.filterDegOnChange = filterDegOnChange;
		$scope.filterCollegeOnChange = filterCollegeOnChange;
		$scope.resetAll = resetAll;
		$scope.filterSectOnChange = filterSectOnChange;
		$scope.filterSkillOnChange = filterSkillOnChange;
		$scope.filterGenderOnChange = filterGenderOnChange;

		$scope.boxChanged = boxChanged;
		$scope.crossButton = crossButton;
		$scope.nameFieldChange = nameFieldChange;
		$scope.checkIfEnterKeyWasPressed = checkIfEnterKeyWasPressed;
		$scope.openDownload = openDownload;
		$scope.getSuggestions = getSuggestions;
		$scope.allLoadMore = allLoadMore;
		$scope.selectedLoadMore = selectedLoadMore;
		$scope.notInNetwork = notInNetwork;
		$scope.updateNetList = updateNetList;
		$scope.notMe = notMe;
		$scope.messageBtnClick = messageBtnClick;
		$scope.stringBuilder1 = stringBuilder1;
		$scope.isAllowed = adminRights.isAllowed;
		$scope.allow_email = allow_email;
		$scope.inviteVia = inviteVia;
		$scope.openLostUserModal = openLostUserModal;

		onResizeWindow(false);
		initDataBind();
		function initDataBind() {

			// var query_string_1 = location.search;
			// console.log(query_string_1);
			// console.log($stateParams);
			// return;
			var urlData = {
				queryString: $stateParams
			};
			// console.log(query_string_1);
			$scope.resetting_waiting = true;
			//if there is some extra filter applied during first stream then we should also fetch lost alumni as we allow it during
			var addFetchLost = Object.keys(urlData.queryString).reduce(function(p,c) {
				if(c !== 'metaTags' && c !== 'pageTitle') {
					return true;
				}
				return p;
			},false);
			console.log('if', 'addFetchLost:', addFetchLost);
			if(addFetchLost) {
				urlData.other_params = {fetch_lost: true};
			}
			sidetopHttp.postDataConfigCall('./search/index_api', urlData,{} ,activate);
		}


		//Activate Function
		function activate(searchInitialData) {
		$scope.resetting_waiting = false;
			if(searchInitialData.errorcode=="LIMIT_EXCEEDED" && searchInitialData.error){
				swal({text: searchInitialData.error, "title":$filter('asPortalLang')('Action_Limit_Restriction',"Access Temporary Restricted")});
			}
			angular.element($window).bind('resize', function () {
				onResizeWindow(true);
			});
			var initialData = searchInitialData.data;
			console.log("pala",initialData);

			$scope.isAdmin = initialData.downloadPermit;

			if (!angular.isUndefined(initialData)) {
				console.log(initialData);
				checkboxes = (initialData.checkboxes.success == 1) ? initialData.checkboxes : {};
				network = (initialData.network) ? initialData.network : [];
				people = (initialData.people.success == 1) ? initialData.peopele : {};
				downloadPermit = (initialData.downloadPermit) ? initialData.downloadPermit : false;
			}

			$scope.totalCount = initialData.totalCount;

			if (initialData.people.success == 1) {
				$scope.resultProfiles = initialData.people.data;
			} else $scope.resultProfiles = [];



			getDepartments();
			fetchAllSectors();
			fetchAllSkills();
			getDegrees();
			subinst1 = getSearchParamChecked(["subinst"], subinst1);
			getSubInstitues();
			setRoleDropdown();

			angular.forEach(searchParams, function (value, key) {
				if (typeof $stateParams[key] !== 'undefined') {
					if (typeof $stateParams[key] == 'string' && (key != 'name')) {
						searchParams[key].push($stateParams[key]);
					} else {
						searchParams[key] = $stateParams[key];
					}
				}
			});
			if (typeof $location.search().name === 'undefined' || $location.search().name === '') {
				searchParams.name = '';
			} else {
				searchParams.name = $location.search().name;
			}

			if (typeof $location.search().role === 'undefined' || $location.search().role === '' || $location.search().role === 0) {
				searchParams.role = [];
				$scope.optionSelected = "0";
			} else {
				searchParams.role = [$location.search().role];
				$scope.optionSelected = $location.search().role;
			}

			$scope.pName = {};
			$scope.pName.basic_info = {};
			$scope.pName.basic_info.name = searchParams.name;
			$scope.displayName = searchParams.name;
			console.log($scope.pName.basic_info.name);
			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['company'])) {
				$scope.companyCheckboxes = checkboxes['data']['company'];
			} else {
				$scope.companyCheckboxes = {};
			}
			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['designation'])) {
				$scope.designationCheckboxes = checkboxes['data']['designation'];
			} else {
				$scope.designationCheckboxes = {};
			}

			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['city'])) {
				$scope.citiesCheckboxes = checkboxes['data']['city'];
			} else {
				$scope.citiesCheckboxes = {};
			}
			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['hometown'])) {
				$scope.hometownCheckboxes = checkboxes['data']['hometown'];
			} else {
				$scope.hometownCheckboxes = {};
			}

			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['department'])) {
				$scope.departmentCheckboxes = checkboxes['data']['department'];
			} else {
				$scope.departmentCheckboxes = {};
			}

			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['degree'])) { //degree case added | Animesh Shah
				$scope.degreeCheckboxes = checkboxes['data']['degree'];
			} else {
				$scope.degreeCheckboxes = {};
			}

			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['yop'])) {
				$scope.yopCheckboxes = checkboxes['data']['yop'];
			} else {
				$scope.yopCheckboxes = {};
			}

			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['sector'])) {
				$scope.sectorCheckboxes = checkboxes['data']['sector'];
			} else {
				$scope.sectorCheckboxes = {};
			}

			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['skill'])) {
				$scope.skillCheckboxes = checkboxes['data']['skill'];
			} else {
				$scope.skillCheckboxes = {};
			}

			if (angular.isDefined(checkboxes['data']) && angular.isDefined(checkboxes['data']['gender'])) {
				$scope.genderCheckboxes = checkboxes['data']['gender'];
			} else {
				$scope.genderCheckboxes = {};
			}

			/**
			 * [intialising people which are to be shown on page load. Variable people comes from search.php view which ultimately is seeded from search.php controller]
			 */

			//Resolve



			if (arrayOfParams.length > 0)
				filterCount();

			angular.element($window).bind("scroll", function () {
				try{
					var resultsDiv = document.getElementById('resultsDiv');
					var contentHeight = resultsDiv.offsetHeight;

					var countDiv = document.getElementById('countDiv');
					var countHeight = countDiv.offsetHeight;

					var filtersDiv = document.getElementById('filtersDiv');
					var filtersHeight = filtersDiv.offsetHeight;

					var yOffset = window.pageYOffset;
					var y = yOffset + window.innerHeight + countHeight + filtersHeight + 75;

					if (y >= contentHeight && ScrollMoreFlag === 0) {
						//console.log('count-height: ' + countHeight);
						//console.log('div-height: ' + contentHeight);
						//console.log('window: ' + y);
						if ($scope.isEmpty === true || $scope.seemoreHide === false) {
							$scope.allLoadMore();
						} else if ($scope.isEmpty === false) {
							$scope.selectedLoadMore();
						}
						as_upgrade(100);
					}
				}
				catch(e) {
					// console.log(e);
				}

			});

			$scope.queryString = stringBuilder();
			//specific for yop search
			$scope.year = [];
			var now = new Date().getFullYear();
			for (var i = now + 5; i >= institute_establish_year; i--) {
					$scope.year.push({
							key: i,
							value: i
					});
			}

			isEmptySearch();



			$scope.$on('$destroy',function() {
				angular.element($window).off("scroll");
				angular.element($window).off("resize");
			})

			var href = $state.href($state.current.name, $location.search(), {absolute: true});
	        if($rootScope.app_data.data.baseState !== '') {
	          href = href.split($rootScope.app_data.data.baseState)[1];
	          href = '/'+$rootScope.app_data.data.baseState+href;
	        }
	        $scope.href = href;
		}


		//Watch Functions
		$scope.$watch('company_id', watchCompany, true);
		$scope.$watch('designation_id', watchDesignation, true);
		$scope.$watch('location_id', watchLocation, true);
		$scope.$watch('hometown_id', watchHometown, true);
		$scope.$watch('subinst_id', watchSubinstitute, true);
		$scope.$watch('department_id', watchDepartment, true);
		$scope.$watch('degree_id', watchDegree, true);
		$scope.$watch('yop_id', watchYOP, true);
		$scope.$on('$locationChangeSuccess', watchQuery,true);


		//Functions

		function openLostUserModal(user,index){
		    if(isEmpty(user.uid)){
		        return;
		    }
		    var params = {};
		    var name = "";
		    if(!isEmpty(user.basic_info.name))
		        name = user.basic_info.name;
		    $scope.resultProfiles[index]["lostModalLoading"] = true;
		    lostUserService.openModal(user.uid,name,params,callback);
		    function callback(data){
		        $scope.resultProfiles[index]["lostModalLoading"] = false;
		    }
		}

		function allow_email(user){
			user['emailInput'] = true;
			as_upgrade(50);
		}

		function inviteVia(type,ev,user) {
			var params1 = $location.search();
			var index = 0;
			var params_str='';
			var params_str_2='';
			angular.forEach(params1,function(value,key){
				if(key !== 'source'){
					params_str += (index?',':'|')+key+':'+value;
					params_str_2 += (index?'&':'?')+key+'='+value;
					index += 1;
				}
			});
			$scope.facebookUrl = window.COMM_APPBASE + 'invite/2/' + $rootScope.app_data.cid + "/" + $rootScope.app_data.uid;
			$scope.facebookUrl += "/search" + params_str_2;
			if(type=="email"){
				invitation.byEmail(ev,{'reason':'search'+params_str});
			}
			if(type=="whatsapp") {
				invitation.byWhatsapp(ev,{'reason':'search'+params_str_2,'name':user.basic_info.name});
			}
			if(type=="facebook") {
				invitation.byFacebook(ev,{'reason':'search'+params_str_2,'name':user.basic_info.name});
			}
			if(type=="email_input") {
				console.log(user);
				user.invitationSending = true;
				var params = {
					lost: user.basic_info.uid
				};
				var name = user.basic_info.name;

				invitation.byEmailInput(name,user.email,params,function(res) {
					user.invitationSending = false;
					if(res.success == 1) {
						user.basic_info.is_lost_user = 0;
						user.invited = true;
						user.emailInput = false;
						snackbar_general(user.basic_info.name+' has been invited.',2000);
					}
					if(res.message) {
						snackbar_general(res.message,2000);
					}
				});
			}
		}

		function watchQuery() {
			var href = $state.href($state.current.name, $location.search(), {absolute: true});
	        if($rootScope.app_data.data.baseState !== '') {
	          href = href.split($rootScope.app_data.data.baseState)[1];
	          href = '/'+$rootScope.app_data.data.baseState+href;
	        }
	        console.log('chnggg ',href);
	        $scope.href = href;
	        // $scope.href = encodeURIComponent((href));
		}

		function watchCompany() {
			if ($scope.company_id != -1) {
				addcheckbox("company"); //calling function to add new company checkbox
				checkboxUsed = 'Company'; //for analytics
			}
		}

		function watchDesignation() {
			if ($scope.designation_id != -1) {
				addcheckbox("designation"); //calling function to add new designation checkbox
				checkboxUsed = 'designation'; //for analytics
			}
		}

		function watchLocation() {
			if ($scope.location_id != -1) {
				addcheckbox("city");
				checkboxUsed = 'City';
			}
		}

		function watchHometown() {
			if ($scope.hometown_id != -1) {
				addcheckbox("hometown");
				checkboxUsed = 'hometown';
			}
		}

		function watchSubinstitute() {
			if ($scope.subinst_id != -1) {
				addcheckbox("subinst");
				checkboxUsed = 'Sub-Institute';
			}
		}

		function watchDepartment() {
			if ($scope.department_id != -1) {
				addcheckbox("department");
				checkboxUsed = 'Department';
			}
		}

		function watchDegree() {
			if ($scope.degree_id != -1) {
				addcheckbox("degree");
				checkboxUsed = 'Degree';
			}
		}

		function watchYOP() {
			if ($scope.yop_id != -1) {
				$scope.yop_name = $scope.yop_id;
				addcheckbox("yop");
				checkboxUsed = 'YOP';
			}
		}

		function onResizeWindow(variable) {
			if (window.innerWidth < 480) {
				$scope.hideFilterSection = true;
			} else {
				$scope.hideFilterSection = false;
			}
			if (variable === true) {
				$scope.$apply();
			}
		}

		function toggleDrawer() {
			if (window.innerWidth < 480) {
				if ($scope.showDrawer === false) {
					$scope.showDrawer = true;
					document.body.style.overflow = "hidden";
				} else {
					$scope.showDrawer = false;
					document.body.style.overflow = "visible";
				}
			}
		}

		function peopleSelected() {
			all_people_stream = 1;
			$scope.showDrawer = false;
			delete searchParams.role;
			// console.log($scope.optionSelected);
			if ($scope.optionSelected == 1 || $scope.optionSelected == 2 || $scope.optionSelected == 3 || $scope.optionSelected == 4) {
				searchParams.role = [$scope.optionSelected];
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
				fetchProfiles();
				filterCount();
				isEmptySearch();
				// console.log(searchParams.role);
				$scope.queryString = stringBuilder();
			} else if ($scope.optionSelected === 0) {
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
				isEmptySearch();
				$scope.queryString = stringBuilder();
				if ($scope.isEmpty === false) {
					fetchProfiles();
					filterCount();
				}
			}
		}

		function getDepartments() {
			return sidetopHttp.postDataCall('./signuser/departmentGet/1', idData, getDepartmentsSuccess);

			function getDepartmentsSuccess(response) {
				if (!angular.isUndefined(response.data)) {
					$scope.departments = response.data;
				}
				$scope.selecftedDept = $scope.departments[0];
				//console.log(response);
				//console.log($scope.departments);
			}

		}

		function setRoleDropdown() {
			$scope.roles = [{code:1,name:"Students"},{code:3,name:"Alumni"},{code:2,name:"Faculty"},{code:4,name:"Admin"}];
			if($rootScope.app_data.data.insti_type==6) {
				$scope.roles = [{code:1,name:"Current Employees"},{code:3,name:"Past Employees"},{code:4,name:"Admin"}];
			}
			// return sidetopHttp.postDataCall(
   //              './signuser/getDropdownData',
   //              {
   //                  id: $rootScope.app_data.cid
   //              },
   //              function(response) {
	  //            	console.log('search.controller.js:548', 'response:', response);
			// 		if (response.signupMeta) {
			// 			if(angular.isDefined(response.signupMeta[1]) && response.signupMeta[1].length>0)
			// 				$scope.roles = response.signupMeta[1];
			// 		}
			// 		console.log('$scope.roles', $scope.roles);
			// 	}
			// );
		}

		function roleStr(code) {
			return $scope.roles.reduce(function(p,c) {
				if(c.code == code)
					p = c.name;
				return p;
			},'');
		}

		function fetchAllSectors() {
			return sidetopHttp.postCall('./jobs/fetch_all_sectors', fetchAllSectorsSuccess);
		}

		function fetchAllSectorsSuccess(response) {
			$scope.sectors = response;
			return response;
		}

		function fetchAllSkills() {
			return sidetopHttp.postCall('./jobs/fetch_all_skills', fetchAllSkillsSuccess);
		}

		function fetchAllSkillsSuccess(response) {
			$scope.skills = response;
			return response;
		}

		function filterDeptOnChange(selectedDept) {
			$scope.department_id = selectedDept.id;
			$scope.department_name = selectedDept.department;
		}

		function getDegrees() {

			return sidetopHttp.postDataCall('./signuser/degreesGet/1', idData, getDegreesSuccess);

			function getDegreesSuccess(response) {
				if (!angular.isUndefined(response.data)) {
					$scope.degrees = response.data;
				}
				$scope.selectedDeg = $scope.degrees[0];
				//console.log(response);
				//console.log($scope.degrees);
			}
		}

		function filterDegOnChange(selectedDeg) {
			$scope.degree_id = selectedDeg.id;
			$scope.degree_name = selectedDeg.degree;
		}

		function getSearchParamChecked(paramAr, arr) {
			for (var i = paramAr.length - 1; i >= 0; i--) {
				$stateParams[paramAr[i]];
				if (angular.isDefined($stateParams[paramAr[i]])) {
					if (angular.isArray($stateParams[paramAr[i]])) {
						angular.extend(arr,$stateParams[paramAr[i]]);
					}else{
						arr.push($stateParams[paramAr[i]]);
					}
				}
			}
			// var searchString = window.location.search.substring(1),
			// 	i, val, params = searchString.split("&");
			// for (i = 0; i < params.length; i++) {
			// 	val = params[i].split("=");
			// 	if (paramAr.indexOf(val[0]) > -1)
			// 		arr.push(val[1]);
			// }
			return arr;
			//console.log(subinst1);
		}

		function getSubInstitues() {
			return sidetopHttp.postDataCall('./search/getSubInst_c/1', idData, getSubInstituesSuccess);

			function getSubInstituesSuccess(response) {
				// console.log(response);
				$scope.sub_inst_successful = response.success;
				if (response.success == 1) {
					var j = 0;
					for (var key in response.count) {
						j++;
						$scope.subInstCheckboxes[key] = response.count[key];
						if (j == limit_inst) break;
					}
					//console.log($scope.subInstCheckboxes);
					$scope.allSubInst = response.count;
					$scope.colleges = response.data;
					$scope.selectedCollege = $scope.colleges[0];
					if (subinst1.length > 0) {
						for (var i = 0; i < subinst1.length; i++) {
							retainSubInstCheckbox(subinst1[i], $scope.allSubInst[subinst1[i]]["name"], $scope.allSubInst[subinst1[i]]["count"]);
						}
					}
				} else {
					$scope.subInstCheckboxes = [];
					$scope.colleges = [];
					$scope.allSubInst = [];
				}
			}
		}

		function filterCollegeOnChange(selectedCollege) {
			$scope.subinst_id = selectedCollege.sub_insti_cid;
			$scope.subinst_name = selectedCollege.name;
		}

		function retainSubInstCheckbox(id, name, count) {
			var data = {
				id: id,
				name: name,
				checked: true,
				count: count
			};

			$scope.subInstCheckboxes[data.id] = data;
			if (searchParams["subinst"].indexOf(id) == -1) {
				searchParams["subinst"].push(id);
			}

			$scope.queryString = stringBuilder();
		}

		function resetAll() {
			searchParams = {};
			$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			$scope.optionSelected = "0";
			var checkboxesFields = [
				'companyCheckboxes',
				'designationCheckboxes',
				'citiesCheckboxes',
				'hometownCheckboxes',
				'departmentCheckboxes',
				'degreeCheckboxes',
				'subInstCheckboxes',
				'yopCheckboxes',
				'sectorCheckboxes',
				'skillCheckboxes',
				'genderCheckboxes',

			];

			angular.forEach(checkboxesFields, function (field) {
				angular.forEach($scope[field], function (value) {
					value["checked"] = false;
				});
			});

			$scope.checked_category = {};
			$scope.queryString = []; //stringBuilder();
			isEmptySearch();
			// $scope.resetting_waiting=false;
			searchParams.company = [];
			searchParams.city = [];
			searchParams.department = [];
			searchParams.degree = [];
			searchParams.yop = [];
			searchParams.subinst = [];
			searchParams.sector = [];
			searchParams.skill = [];
			searchParams.gender = [];
			searchParams.hometown = [];
			searchParams.designation = [];
			delete searchParams.role;
			$scope.pName.basic_info.name = '';
			$scope.displayName = '';
		}

		function filterSectOnChange() {
			addcheckbox("sector");
			checkboxUsed = 'sector';
		}

		function filterSkillOnChange() {
			addcheckbox("skill");
			checkboxUsed = 'skill';
		}
		function filterGenderOnChange() {
			addcheckbox("gender");
			checkboxUsed = 'gender';
		}

		function addcheckbox(type) {
			// console.log(type);
			var data;
			if (type == 'company') {
				data = {
					id: $scope.company_id,
					name: $scope.company_name,
					checked: true
				};
				getCount('company', data.id, function (response) {
					data.count = response.data; //count to be shown on right of a checkbox
					$scope.companyCheckboxes[data.id] = data; //defining checkbox variable
					$scope.boxChanged($scope.company_id, type); //calling function to get data based on this checkbox change
					$scope.company_id = -1; //again intialising to -1
					$scope.company_name = ''; //emptying the text field
				});

			} else if (type == 'designation') {
				data = {
					id: $scope.designation_id,
					name: $scope.designation_name,
					checked: true
				};
				getCount('designation', data.id, function (response) {
					data.count = response.data; //count to be shown on right of a checkbox
					$scope.designationCheckboxes[data.id] = data; //defining checkbox variable
					$scope.boxChanged($scope.designation_id, type); //calling function to get data based on this checkbox change
					$scope.designation_id = -1; //again intialising to -1
					$scope.designation_name = ''; //emptying the text field
				});

			} else if (type == 'city') {
				data = {
					id: $scope.location_id,
					name: $scope.location_name,
					checked: true
				};
				getCount('city', data.id, function (response) {
					data.count = response.data;
					$scope.citiesCheckboxes[data.id] = data;
					$scope.boxChanged(data.id, type);
					$scope.location_id = -1;
					$scope.location_name = '';
				});
			} else if (type == 'hometown') {
				data = {
					id: $scope.hometown_id,
					name: $scope.hometown_name,
					checked: true
				};
				getCount('hometown', data.id, function (response) {
					data.count = response.data;
					$scope.citiesCheckboxes[data.id] = data;
					$scope.boxChanged(data.id, type);
					$scope.hometown_id = -1;
					$scope.hometown_name = '';
				});
			} else if (type == 'subinst') { //case added for sub-institutes | Animesh Shah
				data = {
					id: $scope.subinst_id,
					name: $scope.subinst_name,
					checked: true,
					count: $scope.allSubInst[$scope.subinst_id]['count']
				};
				//var flag=0;
				//if(angular.isUndefined($scope.subInstCheckboxes[data.id])){
				$scope.subInstCheckboxes[data.id] = data;
				//}
				$scope.boxChanged(data.id, type);
				$scope.subinst_id = -1;
				$scope.subinst_name = '';

			} else if (type == 'department') {
				data = {
					id: $scope.department_id,
					name: $scope.department_name,
					checked: true
				};
				getCount('department', data.id, function (response) {
					data.count = response.data;
					$scope.departmentCheckboxes[data.id] = data;
					$scope.boxChanged(data.id, type);
					$scope.department_id = -1;
					$scope.department_name = '';
				});

			} else if (type == 'degree') { //case added for degrees | Animesh Shah
				data = {
					id: $scope.degree_id,
					name: $scope.degree_name,
					checked: true
				};
				getCount('degree', data.id, function (response) {
					data.count = response.data;
					$scope.degreeCheckboxes[data.id] = data;
					$scope.boxChanged(data.id, type);
					$scope.degree_id = -1;
					$scope.degree_name = '';
				});
			} else if (type == 'yop') {
				data = {
					id: $scope.yop_id,
					name: $scope.yop_name,
					checked: true
				};
				getCount('year', data.id, function (response) {
					data.count = response.data;
					$scope.yopCheckboxes[data.id] = data;
					$scope.boxChanged(data.id, type);
					$scope.yop_id = -1;
					$scope.yop_name = '';
				});
			} else if (type == 'sector') {
				data = {
					id: $scope.selectedSect.id,
					name: $scope.selectedSect.name,
					checked: true
				};
				getCount('sector', data.id, function (response) {
					data.count = response.data;
					$scope.sectorCheckboxes[data.id] = data;
					$scope.boxChanged(data.id, type);
					$scope.selectedSect = {};
				});
			} else if (type == 'skill') {
				data = {
					id: $scope.selectedSkill.id,
					name: $scope.selectedSkill.name,
					checked: true
				};
				getCount('sector', data.id, function (response) {
					data.count = response.data;
					$scope.skillCheckboxes[data.id] = data;
					$scope.boxChanged(data.id, type);
					$scope.selectedSkill = {};
				});
			} else if (type == 'gender') {
				data = {
					id: $scope.selectedGender.id,
					name: $scope.selectedGender.name,
					checked: true
				};
				getCount('sector', data.id, function (response) {
					data.count = response.data;
					$scope.genderCheckboxes[data.id] = data;
					$scope.boxChanged(data.id, type);
					$scope.selectedGender = {};
				});
			}
		}

		function boxChanged(id, type, dont_open_drawer) {
			as_upgrade(10);
			if (angular.isUndefined(dont_open_drawer) || !dont_open_drawer) {
				$scope.toggleDrawer();
			}
			var results_top = results_top_div.getBoundingClientRect().top + window.pageYOffset;
			scrollTo(results_top - 150, 100);
			all_people_stream = 1; //adding new checkbox will again make selected stream as 1 as first
			// 10 data is to be recieved for this new search
			ScrollMoreFlag = 0; //flag added to check if more profiles need to be fetched on infinite scroll
			if ($window.innerWidth < 992) {
				$scope.ProbarShown = false;
			}
			searchType = type; //analytics purpose
			if (type == 'company') {
				if ($scope.companyCheckboxes[id]["checked"] === true /*checked*/ ) {
					if (searchParams["company"].indexOf(id) == -1 /*checking if this checkbox was already checked.. just being safe*/ ) {
						searchParams["company"].push(id); //pushing new selected company to search parameters so that search can be made
						//on this new basis and top url can be updated later with this new id
					}
					filterCount(); //called to fetch count every time a new filter is added i.e. when a box is checked/unchecked
					fetchProfiles(); //fetching profiles with new search params
				} else { //checkbox unchecked
					searchParams["company"].splice(searchParams["company"].indexOf(id), 1); //removing this company from searchpramas
					if (searchParams["company"].length > 0) { //still have other companies to search upon
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length === 0 && searchParams["skill"].length === 0 && searchParams["city"].length == 0 && searchParams["department"].length == 0 && searchParams["degree"].length == 0 && searchParams["yop"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) {
							//check others. If everything else is empty, no criteria to select so make result profiles empty
							$scope.resultProfiles = [];
							//isEmptySearch(); function(defined at end of this function) would be called and default frofiles will be shown from all data. without search
						} else {
							filterCount();
							fetchProfiles(); //there are other search criteria left. Lets get data based on these criterias
						}
					}
				}

				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            }); //updating new location based on new search params. URL would change based on this
			} else if (type == 'designation') {
				if ($scope.designationCheckboxes[id]["checked"] === true /*checked*/ ) {
					if (searchParams["designation"].indexOf(id) == -1 /*checking if this checkbox was already checked.. just being safe*/ ) {
						searchParams["designation"].push(id); //pushing new selected designation to search parameters so that search can be made
						//on this new basis and top url can be updated later with this new id
					}
					filterCount(); //called to fetch count every time a new filter is added i.e. when a box is checked/unchecked
					fetchProfiles(); //fetching profiles with new search params
				} else { //checkbox unchecked
					searchParams["designation"].splice(searchParams["designation"].indexOf(id), 1); //removing this designation from searchpramas
					if (searchParams["designation"].length > 0) { //still have other companies to search upon
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["company"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length === 0 && searchParams["skill"].length === 0 && searchParams["city"].length == 0 && searchParams["department"].length == 0 && searchParams["degree"].length == 0 && searchParams["yop"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) {
							//check others. If everything else is empty, no criteria to select so make result profiles empty
							$scope.resultProfiles = [];
							//isEmptySearch(); function(defined at end of this function) would be called and default frofiles will be shown from all data. without search
						} else {
							filterCount();
							fetchProfiles(); //there are other search criteria left. Lets get data based on these criterias
						}
					}
				}

				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            }); //updating new location based on new search params. URL would change based on this
			} else if (type == 'city') {
				if ($scope.citiesCheckboxes[id]["checked"] == true) {
					if (searchParams["city"].indexOf(id) == -1) {
						searchParams["city"].push(id);
					};
					filterCount();
					fetchProfiles();
				} else {
					searchParams["city"].splice(searchParams["city"].indexOf(id), 1);
					if (searchParams["city"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length == 0 && searchParams["skill"].length == 0 && searchParams["company"].length == 0 && searchParams["department"].length == 0 && searchParams["degree"].length == 0 && searchParams["yop"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			} else if (type == 'hometown') {
				if ($scope.hometownCheckboxes[id]["checked"] == true) {
					if (searchParams["hometown"].indexOf(id) == -1) {
						searchParams["hometown"].push(id);
					};
					filterCount();
					fetchProfiles();
				} else {
					searchParams["hometown"].splice(searchParams["hometown"].indexOf(id), 1);
					if (searchParams["hometown"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["city"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length == 0 && searchParams["skill"].length == 0 && searchParams["company"].length == 0 && searchParams["department"].length == 0 && searchParams["degree"].length == 0 && searchParams["yop"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			} else if (type == 'subinst') { //case added for sub-institutes | Animesh Shah
				if ($scope.subInstCheckboxes[id]["checked"] == true) {
					if (searchParams["subinst"].indexOf(id) == -1) {
						searchParams["subinst"].push(id);
					}
					filterCount();
					fetchProfiles();
				} else {
					searchParams["subinst"].splice(searchParams["subinst"].indexOf(id), 1);
					if (searchParams["subinst"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length == 0 && searchParams["skill"].length == 0 && searchParams["company"].length == 0 && searchParams["city"].length == 0 && searchParams["department"].length == 0 && searchParams["degree"].length == 0 && searchParams["yop"].length == 0 && searchParams.name == '' && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			} else if (type == 'department') {
				if ($scope.departmentCheckboxes[id]["checked"] == true) {
					if (searchParams["department"].indexOf(id) == -1) {
						searchParams["department"].push(id);
					}
					filterCount();
					fetchProfiles();
				} else {
					searchParams["department"].splice(searchParams["department"].indexOf(id), 1);
					if (searchParams["department"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length == 0 && searchParams["skill"].length == 0 && searchParams["company"].length == 0 && searchParams["city"].length == 0 && searchParams["yop"].length == 0 && searchParams["degree"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			} else if (type == 'degree') { //case added for sub-institutes | Animesh Shah
				if ($scope.degreeCheckboxes[id]["checked"] == true) {
					if (searchParams["degree"].indexOf(id) == -1) {
						searchParams["degree"].push(id);
					}
					filterCount();
					fetchProfiles();
				} else {
					searchParams["degree"].splice(searchParams["degree"].indexOf(id), 1);
					if (searchParams["degree"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length == 0 && searchParams["skill"].length == 0 && searchParams["company"].length == 0 && searchParams["city"].length == 0 && searchParams["yop"].length == 0 && searchParams["department"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			} else if (type == 'yop') {
				if ($scope.yopCheckboxes[id]["checked"] == true) {
					if (searchParams["yop"].indexOf(id) == -1) {
						searchParams["yop"].push(id);
					}
					filterCount();
					fetchProfiles();
				} else {
					searchParams["yop"].splice(searchParams["yop"].indexOf(id), 1);
					if (searchParams["yop"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length == 0 && searchParams["skill"].length == 0 && searchParams["company"].length == 0 && searchParams["city"].length == 0 && searchParams["department"].length == 0 && searchParams["degree"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			} else if (type == 'sector') { //case added for sub-institutes | Animesh Shah
				if ($scope.sectorCheckboxes[id]["checked"] == true) {
					console.log(searchParams);
					if (searchParams["sector"].indexOf(id) == -1) {
						searchParams["sector"].push(id);
					}
					filterCount();
					fetchProfiles();
				} else {
					searchParams["sector"].splice(searchParams["sector"].indexOf(id), 1);
					if (searchParams["sector"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["skill"] && searchParams["degree"].length == 0 && searchParams["company"].length == 0 && searchParams["city"].length == 0 && searchParams["yop"].length == 0 && searchParams["department"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			} else if (type == 'skill') { //case added for sub-institutes | Animesh Shah
				if ($scope.skillCheckboxes[id]["checked"] == true) {
					if (searchParams["skill"].indexOf(id) == -1) {
						searchParams["skill"].push(id);
					}
					filterCount();
					fetchProfiles();
				} else {
					searchParams["skill"].splice(searchParams["skill"].indexOf(id), 1);
					if (searchParams["skill"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["gender"].length == 0 && searchParams["sector"].length == 0 && searchParams["degree"].length == 0 && searchParams["company"].length == 0 && searchParams["city"].length == 0 && searchParams["yop"].length == 0 && searchParams["department"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			}else if (type == 'gender') { //case added for sub-institutes | Animesh Shah
				if ($scope.genderCheckboxes[id]["checked"] == true) {
					if (searchParams["gender"].indexOf(id) == -1) {
						searchParams["gender"].push(id);
					}
					filterCount();
					fetchProfiles();
				} else {
					searchParams["gender"].splice(searchParams["gender"].indexOf(id), 1);
					if (searchParams["gender"].length > 0) {
						filterCount();
						fetchProfiles();
					} else {
						if (searchParams["designation"].length == 0 && searchParams["hometown"].length == 0 && searchParams["skill"].length == 0 && searchParams["sector"].length == 0 && searchParams["degree"].length == 0 && searchParams["company"].length == 0 && searchParams["city"].length == 0 && searchParams["yop"].length == 0 && searchParams["department"].length == 0 && searchParams.name == '' && searchParams["subinst"].length == 0 && angular.isUndefined(searchParams["role"])) { //check other
							$scope.resultProfiles = [];
						} else {
							filterCount();
							fetchProfiles();
						}
					}
				}
				$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			}
			$scope.queryString = stringBuilder(); //this is used to display the filter blocks for each filter added
			isEmptySearch(); //function called to see if there is no criteria is there to search anything. It will switch view to all profiles
		}

		function crossButton(id, type) {
			if (type == 'company') {
				$scope.companyCheckboxes[id]["checked"] = false;
			}
			if (type == 'designation') {
				$scope.designationCheckboxes[id]["checked"] = false;
			}
			if (type == 'city') {
				$scope.citiesCheckboxes[id]["checked"] = false;
			}
			if (type == 'hometown') {
				$scope.hometownCheckboxes[id]["checked"] = false;
			}
			if (type == 'department') {
				$scope.departmentCheckboxes[id]["checked"] = false;
			}
			if (type == 'degree') {
				$scope.degreeCheckboxes[id]["checked"] = false;
			}
			if (type == 'yop') {
				$scope.yopCheckboxes[id]["checked"] = false;
			}
			if (type == 'subinst') {
				$scope.subInstCheckboxes[id]["checked"] = false;
			}
			if (type == 'role') {
				$scope.optionSelected = 0;
				$scope.peopleSelected();
			}
			if (type == 'sector') {
				$scope.sectorCheckboxes[id]["checked"] = false;
			}
			if (type == 'skill') {
				$scope.skillCheckboxes[id]["checked"] = false;
			}
			if (type == 'gender') {
				$scope.genderCheckboxes[id]["checked"] = false;
			}
			$scope.boxChanged(id, type, true);
		}

		function nameFieldChange() {
			all_people_stream = 1; //Stream intialisation as this is fresh search
			searchType = 'name';
			var searchName = $scope.pName.basic_info.name;
			$scope.displayName = $scope.pName.basic_info.name;
			// if (searchName.trim()!="") { commented by palash
			searchParams["name"] = searchName.trim();
			filterCount();
			fetchProfiles();
			// }//commented by palash
			searchParams["name"] = searchName.trim();
			$state.go('inapp.search',
					searchParams, {
	                notify: false,
	                location: 'replace'
	            });
			// if(isFetching==false){sendAnalytics();}			//for sending analytics
			isEmptySearch();
		}

		function checkIfEnterKeyWasPressed($event) {
			var keyCode = $event.which || $event.keyCode;
			if (keyCode === 13) {
				$scope.nameFieldChange();
			}
		}

		function openDownload(event) {
			$scope.test = {};
			$scope.test.pwd = '';
			$scope.downloadEmptyWarning = false;
			$scope.downloadWarning = false;
			$scope.displayFilters = stringBuilder();
			$scope.showDownloadLoading = false;
			$scope.waitingText = '';
			ModalService.showModal({
				scope: $scope,
				templateUrl: './templates/modals/downloadModal_md.html',
				controller: 'OpenDownloadSearchModalController',
				target: event.target
			}).then(openDownloadSearchModalCallback);

			function openDownloadSearchModalCallback(modal) {
				modal.close.then(function () {
					// console.log(result);
				});
			}
		}

		function getSuggestions(uid, uui, role_id, event) {
			var suggestionsData = {
				uid: uid,
				submitText: 'Make Life Member',
				target: event.target
			};


			suggestions.getSuggestions(suggestionsData, suggestionsCallback);

			function suggestionsCallback(result) {
				// console.log(result.id); return;
				var uuiData = {
					uui: uui
				};

				var updateCollegeTableData = {
					id: result.id,
					probability: result.probability,
					roleId: role_id
				};

				sidetopHttp.postDataCall('./checkout/life_membership/temp_lm', uuiData, successCallback);
				sidetopHttp.postDataCall('./admin/updateCollegeTable', updateCollegeTableData, successCallback);

				function successCallback(response) {
					// console.log('made');
				}
			}
		}

		function fetchProfiles(type) {
			// console.log('fetching')
			var dataTosend;

			if (canceller != undefined) {
				canceller.resolve();
				// console.log('request cancelled');
			}
			canceller = $q.defer();
			ScrollMoreFlag = 1; //flag that makes sure that no more values are fetched
			if (type == "all") {
				dataTosend = {
					rnd: randomDefault,
					stream: allDataStream
				};
				$scope.isFetching1 = true; //while this variabloe is true a loader would be shown in frontend
				if (allDataStream == 1) {
					$scope.resetting_waiting = true;
				}
				if(!dataTosend.other_params) {
					dataTosend.other_params = {};
				}
				dataTosend.other_params.fetch_lost = false;
			} else {
				dataTosend = angular.copy(searchParams);
				dataTosend['stream'] = all_people_stream;
				$scope.isFetchingSelected = true;
				if (all_people_stream == 1 /*when a new criteria used for first time*/ ) {
					$scope.resultProfiles = [];
					$scope.resetting_waiting = true; //this will make whole screen white/fade
				};
				if(!dataTosend.other_params) {
					dataTosend.other_params = {};
				}
				dataTosend.other_params.fetch_lost = true;
			}
			// isFetching=true;//this variable is mainly used to send proper analytics
			var configObject = {
				timeout: canceller.promise
			};
			if($rootScope.app_data.same_com_log)
				return sidetopHttp.postDataConfigCall('./search/UserSearch', dataTosend, configObject, userSearchSuccess);
			else{
				dataTosend.rnd = 0;
				return sidetopHttp.postDataConfigCall('./search/UserSearch', dataTosend, configObject, userSearchSuccess);
				// userSearchSuccess({success:0});
			}


			function userSearchSuccess(response) {
				$scope.isFetching1 = false;
				$scope.isFetchingSelected = false;
				// isFetching=false;
				if ($scope.resetting_waiting) {
					$scope.resetting_waiting = false;
					// window.scrollTo(0, 0);
				};
				if (response.success == 1) {
					ScrollMoreFlag = 0; //means that there are still more values to be fetched
					if (type == "all") {
						allDataStream++;
						allPeople = allPeople.concat(response.data);
						$scope.resultProfiles = allPeople;
					} else {
						all_people_stream++;
						$scope.resultProfiles = $scope.resultProfiles.concat(response.data);
					}
				} else {
					if(response.success == 0 && response.errorcode == "LIMIT_EXCEEDED"){
						swal({text: response.error, "title":$filter('asPortalLang')('Action_Limit_Restriction',"Access Temporary Restricted")});
					}
					ScrollMoreFlag = 1; // no more values, don't call filterCount() again
					if (type == "all") {
						$scope.seemoreHide = true;
					}
				}
				if(!$rootScope.app_data.same_com_log) {
					ScrollMoreFlag = 1;
					$scope.showLoginCard = ($scope.totalCount.count-$scope.resultProfiles.length) >= 10;
				}
				as_upgrade(100);
				
				// if(isFetching==false && type!="all"){sendAnalytics();}
			}
		}

		function filterCount() {
			var dataTosend;
			if (canceller1 != undefined) {
				canceller1.resolve();
				// console.log('request cancelled');
			}
			canceller1 = $q.defer();

			dataTosend = angular.copy(searchParams);
			//dataTosend['stream'] = all_people_stream;
			if(!dataTosend.other_params) {
				dataTosend.other_params = {};
			}
			dataTosend.other_params.fetch_lost = true;
			$scope.isFetchingSelected = true;

			var configObject = {
				timeout: canceller1.promise
			};

			return sidetopHttp.postDataConfigCall('./search/filterCount', dataTosend, configObject, filterCountSuccess);

			function filterCountSuccess(response) {
				//console.log(response);
				$scope.isFetchingSelected = false;
				if (response.success == 1) {
					$scope.resultCount = response.data;
					sendAnalytics(); //this function is called from here only, put in comments everywhere else
				}
			}
		}

		function getCount(type, id, callback) {
			var getCountData = {
				type: type,
				id: id
			};
			return sidetopHttp.postDataCall('./search/getCount', getCountData, getCountSuccess);

			function getCountSuccess(response) {
				var d;
				if (response.success == 1 && response.data != null) {
					d = response;
				} else {
					d = {
						data: 0
					};
				}
				callback(d);
			}
		}

		function allLoadMore() {
			fetchProfiles('all');
		}

		function selectedLoadMore() {
			fetchProfiles();
		}

		function stringBuilder1() {
			// if(isFetching==false){sendAnalytics();}
			var dynamicString = ''
			var checkbox;
			var initialisation;
			angular.forEach(searchParams, function (value, key) {
				if (key == 'company') {
					checkbox = 'companyCheckboxes';
					initialisation = "Work at"
				}
				if (key == 'designation') {
					checkbox = 'designationCheckboxes';
					initialisation = "Designated as"
				}
				if (key == 'city') {
					checkbox = 'citiesCheckboxes';
					initialisation = "Live in"
				}
				if (key == 'hometown') {
					checkbox = 'hometownCheckboxes';
					initialisation = "Hometown is"
				}
				if (key == 'department') {
					checkbox = 'departmentCheckboxes';
					initialisation = "Graduated from"
				}
				if (key == 'degree') {
					checkbox = 'degreeCheckboxes';
					initialisation = "Have a degree in"
				}
				if (key == 'yop') {
					checkbox = 'yopCheckboxes';
					initialisation = "Graduated in"
				}
				if (key == 'subinst') {
					checkbox = 'subInstCheckboxes';
					initialisation = "Of Sub Institute"
				}
				if (key == 'sector') {
					checkbox = 'sectorCheckboxes';
					initialisation = "from business domain"
				}
				if (key == 'skill') {
					checkbox = 'skillCheckboxes';
					initialisation = "having skill"
				}if (key == 'gender') {
					checkbox = 'genderCheckboxes';
					initialisation = "of gender"
				}
				if(key=='role')
				{
					if(searchParams.role.indexOf("1") > -1 || searchParams.role.indexOf(1) > -1)
						dynamicString = dynamicString + " " + "Who are Students";
					else if(searchParams.role.indexOf("2") > -1 || searchParams.role.indexOf(2) > -1)
						dynamicString = dynamicString + " " + "Who are Faculty";
					else if(searchParams.role.indexOf("3") > -1 || searchParams.role.indexOf(3) > -1)
						dynamicString = dynamicString + " " + "Who are Alumni";
					else if(searchParams.role.indexOf("4") > -1 || searchParams.role.indexOf(4) > -1)
						dynamicString = dynamicString + " " + "Who are Admin";
				}

				if (key == 'name') {
					if (value)
						dynamicString = dynamicString + " " + "For `" + value + "`";
				}
				if (value.length != 0 && key != 'name' && key != 'role') {
					if (dynamicString != '') {
						dynamicString = dynamicString + ' and'
					};
					dynamicString = dynamicString + " " + initialisation
					dynamicString = dynamicString + " " + $scope[checkbox][value[0]]["name"];
					for (var i = 1; i < value.length; i++) {
						dynamicString = dynamicString + " or " + $scope[checkbox][value[i]]["name"];
					};
				};
			});
			return dynamicString;
		}

		function stringBuilder() {
			// if(isFetching==false){sendAnalytics();}
			var dynamicString = ''
			var filterArray = [];
			var checkbox;
			var initialisation;
			//console.log(searchParams);
			//console.log($scope.yopCheckboxes);
			$scope.checked_category = {};
			angular.forEach(searchParams, function (value, key) {
				if (value != null && value != '') {
					$scope.checked_category[key] = true;
				};

				if (key == 'company') {
					checkbox = 'companyCheckboxes';
					initialisation = "company"
				}
				if (key == 'designation') {
					checkbox = 'designationCheckboxes';
					initialisation = "designation"
				}
				if (key == 'city') {
					checkbox = 'citiesCheckboxes';
					initialisation = "city"
				}
				if (key == 'hometown') {
					checkbox = 'hometownCheckboxes';
					initialisation = "hometown"
				}
				if (key == 'department') {
					checkbox = 'departmentCheckboxes';
					initialisation = "department"
				}
				if (key == 'degree') {
					checkbox = 'degreeCheckboxes';
					initialisation = "degree"
				}
				if (key == 'yop') {
					checkbox = 'yopCheckboxes';
					initialisation = "yop"
				}
				if (key == 'subinst') {
					checkbox = 'subInstCheckboxes';
					initialisation = "subinst"
				}
				if (key == 'sector') {
					checkbox = 'sectorCheckboxes';
					initialisation = "sector"
				}
				if (key == 'skill') {
					checkbox = 'skillCheckboxes';
					initialisation = "skill"
				}if (key == 'gender') {
					checkbox = 'genderCheckboxes';
					initialisation = "gender"
				}
				console.log(key);
				if(key=='role') {
					if(searchParams.role.indexOf("1") > -1 || searchParams.role.indexOf(1) > -1)
						filterArray.push({key:'role', value: roleStr(1), id: ''});
					else if(searchParams.role.indexOf("2") > -1 || searchParams.role.indexOf(2) > -1)
						filterArray.push({key:'role', value: roleStr(2), id: ''});
					else if(searchParams.role.indexOf("3") > -1 || searchParams.role.indexOf(3) > -1)
						filterArray.push({key:'role', value: roleStr(3), id: ''});
					else if(searchParams.role.indexOf("4") > -1 || searchParams.role.indexOf(4) > -1)
						filterArray.push({key:'role', value: roleStr(4), id: ''});
				}
				if (value.length != 0 && key != 'name' && key!='role') {
					for (var i = 0; i < value.length; i++) {
						if ($scope[checkbox][value[i]] != undefined) {
							filterArray.push({
								key: initialisation,
								value: $scope[checkbox][value[i]]["name"],
								id: $scope[checkbox][value[i]]["id"]
							});
						}
					};
				};
			});
			return filterArray;
		}

		function notInNetwork(uui) {
			if (network.indexOf(String(uui)) == -1) {
				return true;
			} else return false;
		}

		function updateNetList(uui) {
			snackbar_general("Added to "+$filter('asLingo')('35'), 2500);
			network.push(uui);
		}

		function notMe(uid) {
			if (myUid == uid) {
				return false
			} else return true;
		}

		function messageBtnClick(name, uui, uid,event) {
			var user = {
				name: name,
				uui: uui,
				uid: uid
			}
			asMessages.openSendBox(user, event.target, null, {hideChips: true});
		}

		function isEmptySearch() {
			$scope.isEmpty = true;
			angular.forEach(searchParams, function (value, key) {
				// console.log(value);
				// console.log(key);
				if (typeof value == 'string' /*name field*/ ) {
					if (value != '') {
						$scope.isEmpty = false;
					}
				} else {
					if (value.length > 0) {
						$scope.isEmpty = false;
					}
				}
			})
			if ($scope.isEmpty == true) {
				all_people_stream = 1;
				if (allPeople.length == 0) {
					fetchProfiles('all');
				} else {
					$scope.resultProfiles = allPeople;
				}
			}
		}

		function sendAnalytics() {
			if(!$rootScope.app_data.same_com_log)
				return;
			if (new Date().getTime() - searchTime > 8000) {
				console.log("tracking now")
					// mixpanel.track("Search Page Usage",
					// {
					// 	"Search Number":searchNo,
					// 	"Profile Count":($filter('filter')($scope.resultProfiles,$scope.pName)).length,
					// 	"Count Sub-Institutes": searchParams.subinst.length,
					// 	"Count YOP":searchParams.yop.length,
					// 	"Count Department":searchParams.department.length,
					// 	"Count Degree": searchParams.department.length,
					// 	"Count company":searchParams.company.length,
					// 	"Count city":searchParams.city.length,
					// 	"Length name":searchParams.name.length,
					// 	"Checkbox Used":checkboxUsed,
					// 	"searchType":searchType
					// });
				var analyticsData = {
					count: $scope.resultCount[0].count,
					params: searchParams,
					index: searchNo
				};

				return sidetopHttp.postDataCall('./search/track_searches', analyticsData, sendAnalyticsSuccess);

				function sendAnalyticsSuccess(response) {
					searchNo++;
				}

				searchTime = new Date().getTime();
				checkboxUsed = 'none';
			}
		}
	}

	OpenDownloadSearchModalController.$inject = ['$scope', 'close', 'sidetopHttp','$timeout','$http','fileDownload'];

	function OpenDownloadSearchModalController($scope, close, sidetopHttp,$timeout,$http,fileDownload) {
		as_upgrade(10);
		$scope.close = close;
		$scope.okClick = okClick;
		$scope.changePasswordButton = changePasswordButton;
		function changePasswordButton() {
			showSpinner();
	        $http.post('./changepassword/logged_in_api?redirect=search').then(function(res) {
	          hideSpinner();
	          if (res.data && res.data.success==1) {
	            swal("A mail has been sent to your registered email id with instructions to set password.");
	          }
	          else if(res.data && res.data.success == 0 && res.data.errorcode == "LIMIT_EXCEEDED"){
	          	swal({text: res.data.error, "title":$filter('asPortalLang')('Action_Limit_Restriction',"Access Temporary Restricted")});
	          }
	        });
			close();
		}

		function okClick(event) {
			var password = $scope.test.pwd;
			if (password != '' && password != null) {
				var data = {
					enteredPass: password
				};

				return sidetopHttp.postDataCall('./search/checkPasswordOnDownload', data, checkPasswordSuccess);

			} else {
				$scope.downloadWarning = false;
				$scope.downloadEmptyWarning = true;
			}

			function checkPasswordSuccess(response) {
				if (response.success == 1) {

					$scope.downloadWarning = false;
					$scope.downloadEmptyWarning = false;
					$scope.showDownloadLoading = true;
					$timeout(function () {
						$scope.waitingText = 'Authenticating...';
						$timeout(function () {
							$scope.waitingText = 'Fetching results....';
							$timeout(function () {
								$scope.waitingText = 'Downloading...';
								$timeout(function () {
									$scope.showDownloadLoading = false;
									close(event);
									var filterString = $scope.stringBuilder1();
									if(window.location.search.indexOf("?")===-1) var search = window.location.search+"?other_params[fetch_lost]=true";
									else var search = window.location.search+"&other_params[fetch_lost]=true";
									search = search +'&search_string' + encodeURIComponent(filterString).replace(/\(/g,"%28").replace(/\)/g,"%29");
									fileDownload.do(window.API_BASE_URL + 'search/download_new' + search,'csv','text/csv');
									// document.location = window.API_BASE_URL + 'search/download_new/' + encodeURIComponent(filterString).replace(/\(/g,"%28").replace(/\)/g,"%29") + search;
								}, 1000);
							}, 2000);
						}, 2000);
					}, 0);
				} else {
					$scope.downloadEmptyWarning = false;
					$scope.downloadWarning = true;
				}
			}
		}
	}
})();
